export default "<div class=\"voltar\" (click)=\"voltar()\">\r\n  <mat-icon>keyboard_arrow_left</mat-icon>\r\n</div>";